"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PX_HIDE_FINISH = exports.REACT_APP_WITH_CREDENTIALS = exports.REACT_APP_MY_ACCOUNT_BASE_WIDGET_URL = exports.REACT_APP_SESSION_COOKIE_DOMAIN = exports.REACT_APP_SESSION_LIFETIME = exports.REACT_APP_SESSION_COOKIE_NAME = exports.REACT_APP_SESSION_HEADER = exports.BE_BASE_URL = exports.ENVIRONMENT = void 0;
const urlJoin = require("url-join");
exports.ENVIRONMENT = process.env.ENVIRONMENT;
exports.BE_BASE_URL = process.env.PLATFORM_API_URL;
exports.REACT_APP_SESSION_HEADER = process.env.REACT_APP_SESSION_HEADER;
exports.REACT_APP_SESSION_COOKIE_NAME = process.env.REACT_APP_SESSION_COOKIE_NAME;
exports.REACT_APP_SESSION_LIFETIME = process.env.REACT_APP_SESSION_LIFETIME;
exports.REACT_APP_SESSION_COOKIE_DOMAIN = process.env.REACT_APP_SESSION_COOKIE_DOMAIN;
exports.REACT_APP_MY_ACCOUNT_BASE_WIDGET_URL = urlJoin(process.env.REACT_APP_MY_ACCOUNT_BASE_WIDGET_URL, 'library/widgets.js');
exports.REACT_APP_WITH_CREDENTIALS = process.env.REACT_APP_WITH_CREDENTIALS;
exports.PX_HIDE_FINISH = Boolean(process.env.PX_HIDE_FINISH);
